
import { Component, Vue, Prop } from "vue-property-decorator";
import { getXinzangList, patientDetail } from "@/request/doctor";
import MenzhenJilu from "./components/menzhen-jilu/menzhen-jilu.vue";
import Yidongshebei from "./components/yidongshebei/yidongshebei.vue";
import Jianchashebei from "./components/jianchashebei/jianchashebei.vue";
import GanyuJilu from "./components/ganyu-jilu/ganyu-jilu.vue";
import EditMessage from "./components/edit-message/edit-message.vue";
@Component({
  components: {
    MenzhenJilu,
    Yidongshebei,
    Jianchashebei,
    GanyuJilu,
    EditMessage,
  },
})
export default class DanganDetail extends Vue {
  private id: any = "";
  private tab: any = "门诊记录";
  private get patient() {
    return this.$store.state.patient;
  }
  private goBack() {
    this.$router.back();
  }
  /**
   * @desc 获取患者个人信息
   */
  private fetchPatient() {
    console.log("111111111111");
    if (!this.id) {
      return;
    }
    const params = {
      patient_id: this.id,
      source: "pc医生",
    };
    patientDetail(this, params).then((data: any) => {
      this.$store.commit("updatePatient", data);
      console.log(data);
    });
  }
  private changeTab(type: any) {
    this.tab = type;
  }
  mounted() {
    this.id = this.$route.query.id;
    this.tab = this.$route.query.part;
    this.fetchPatient();
  }
}
